import type { CareerPlanAssessmentAnswer } from "./careerPlanHistory";

export function groupExperienceIndexAnswers(answers: CareerPlanAssessmentAnswer[]) {
  const groups: CareerPlanAssessmentAnswer[][] = [];
  const indexByCompetencyId = new Map<string, number>();

  for (const answer of answers) {
    const existingIndex = indexByCompetencyId.get(answer.competencyId);
    if (existingIndex == null) {
      indexByCompetencyId.set(answer.competencyId, groups.length);
      groups.push([answer]);
      continue;
    }

    groups[existingIndex].push(answer);
  }

  return groups;
}

export function focusedExperienceIndexAnswerGroups(
  answers: CareerPlanAssessmentAnswer[],
  focusedCompetencyId?: string | null
) {
  const groups = groupExperienceIndexAnswers(answers);
  if (!focusedCompetencyId) {
    return groups;
  }

  return groups.filter((group) => group[0].competencyId === focusedCompetencyId);
}
